module.exports = __webpack_public_path__ + "static/media/alf3.911f5935.jpg";